import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AppEnum } from 'src/app/appenum';
import { EncryptionService } from './encryption.service';

@Injectable()
export class sessionInterceptor implements HttpInterceptor {
  constructor(private _appenum: AppEnum, public encryptionService: EncryptionService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.authtoken));
    var headers;
    if (authToken) {
      const authHeader = `Bearer ${authToken}`;
      headers = new HttpHeaders({
        // 'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'X-Frame-Options': 'deny',
        'X-Content-Type-Options': 'nosniff',
        'X-XSS-Protection': '1; mode=block',
        'Content-Security-Policy': "frame-ancestors 'self'",
        'Authorization': authHeader,
        'Cache-Control': 'no-cache',
        'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
        'ReqBodyenc': 'true'
      });
    }
    else {
      headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'X-Frame-Options': 'DENY',
        'X-Content-Type-Options': 'nosniff',
        'X-XSS-Protection': '1; mode=block',
        'ReqBodyenc': 'true',
        'Content-Security-Policy': "frame-ancestors 'self'"
      });
    }
    const authReq = req.clone({ headers });
    return next.handle(authReq);
  }
}
